import React from "react";
import { Table, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import FooterPagination from "../../Pagination/FooterPagination";
import {
  formatDate,
  formatMonthAndYear,
  parsedInvoiceAmount,
} from "../../../utils/utils";
import UserStatusBadge from "../../Badges/UserStatusBadge";
import { singularRoleLabels } from "../../../constants";

const CommissionsTable = ({ data, paginationProps, isAdmin, onArchive, showArchived }) => {
  const navigate = useNavigate();

  const { id } = useParams();
  const isProfilePage = id;

  const handleRowClick = (commissionId, event) => {
    const selection = window.getSelection().toString();
    if (!selection) {
      navigate(
        `${isAdmin && isProfilePage ? "/commissions/" : ""
        }commissionDetail/${commissionId}`
      );
    }
  };

  const handleVisitProfile = (role, userId) => {
    if (role && userId) {
      navigate(`/${role}/${userId}`);
    }
  };

  return (
    <Table className="table table-hover border table-centered align-middle table-nowrap mb-0">
      <thead className="bg" style={{ background: "var(--thead-bg)" }}>
        <tr>
          <th scope="col">Name</th>
          {isAdmin && <th scope="col">Entity</th>}
          <th scope="col">Commission Coverage</th>
          <th scope="col">Created On</th>
          <th scope="col">Balance Total</th>
          <th scope="col">Payment Status</th>
          {onArchive && <th scope="col" className="text-center">Actions</th>}
        </tr>
      </thead>
      <tbody>
        {data.length === 0 ? (
          <tr>
            <td className="text-center" colSpan={onArchive ? 7 : 6}>
              No commissions yet
            </td>
          </tr>
        ) : (
          data &&
          data?.map((commission, index) => {
            const dashboardUserInfo = commission.dashboardUserInfo;
            const nameColumn = commission.dashboardUserInfo?.companyName
              ? `${dashboardUserInfo?.companyName} (${dashboardUserInfo?.email})`
              : `${dashboardUserInfo?.firstName} ${dashboardUserInfo?.lastName} (${dashboardUserInfo?.email})`;

            const entity = commission.dashboardUserInfo?.role
              ? singularRoleLabels[commission.dashboardUserInfo?.role]
              : "N/A";

            return (
              <tr
                key={index}
                onClick={(event) => handleRowClick(commission.id, event)}
                className="cursor-pointer"
              >
                <td

                >
                  <span
                    className={
                      isAdmin ? "text-hover-underlined text-hover-bax" : ""
                    }
                    onClick={(event) => {
                      event.stopPropagation();
                      if (isAdmin) {
                        console.log(
                          "commission.dashboardUserInfo?.role",
                          commission.dashboardUserInfo?.role
                        );
                        console.log(
                          "commission.dashboardUserInfo?.userId",
                          commission.dashboardUserInfo?.id
                        );
                        handleVisitProfile(
                          commission.dashboardUserInfo?.role,
                          commission.dashboardUserInfo?.id
                        );
                      }
                    }}
                  >
                    {" "}
                    {nameColumn}
                  </span>
                </td>
                {isAdmin && (
                  <td>
                    {singularRoleLabels[commission.dashboardUserInfo?.role] ||
                      "N/A"}
                  </td>
                )}
                <td>{formatMonthAndYear(commission.effectiveForDate)}</td>
                <td>{formatDate(commission.createdAt)}</td>
                <td>${parsedInvoiceAmount(commission.totalAmount) || "0"}</td>
                <td className="text-start" style={{ paddingLeft: "2.3rem" }}>
                  <UserStatusBadge
                    status={commission?.paid == true ? "Paid" : "Pending"}
                    color={commission?.paid == true ? "success" : "warning"}
                  />
                </td>
                {onArchive && (
                  <td className="text-center">
                    {!commission.paid && (
                      <Button
                        color={showArchived ? "soft-primary" : "soft-secondary"}
                        size="sm"
                        className="btn-icon"
                        title={showArchived ? "Unarchive" : "Archive"}
                        onClick={(e) => {
                          e.stopPropagation();
                          onArchive(commission);
                        }}
                      >
                        <i className={showArchived ? "ri-inbox-unarchive-line" : "ri-archive-line"}></i>
                      </Button>
                    )}
                  </td>
                )}
              </tr>
            );
          })
        )}
      </tbody>
      {paginationProps.totalItems > 0 && (
        <tfoot>
          <FooterPagination {...paginationProps} />
        </tfoot>
      )}
    </Table>
  );
};

export default CommissionsTable;
